import {useAuth0} from '@auth0/auth0-react'
import {QueryClient, QueryClientProvider} from '@tanstack/react-query'
import {httpLink} from '@trpc/client'
import {type PropsWithChildren, useState} from 'react'
import {config} from '../../config.ts'
import {api} from '../../trpc/api.ts'

export const TrpcProvider = ({children}: PropsWithChildren) => {
  const {getIdTokenClaims, getAccessTokenSilently} = useAuth0()

  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 0,
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
            retry: 1,
            retryDelay: 2_500,
          },
          mutations: {
            retry: false,
          },
        },
      }),
  )

  const [trpcClient] = useState(() =>
    api.createClient({
      links: [
        httpLink({
          url: config.restApi.url,
          headers: async () => {
            await getAccessTokenSilently()
            const idToken = (await getIdTokenClaims())?.__raw
            return {
              Authorization: `Bearer ${idToken}`,
            }
          },
        }),
      ],
    }),
  )

  return (
    <api.Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </api.Provider>
  )
}
